import React from 'react';
import { Card } from 'react-bootstrap';

const Music = () => {
    return <Card style={{textAlign: 'center', fontSize: '20px', height: '100px'}}>Данный раздел в разработке</Card>
}

export default Music;